// extracted by mini-css-extract-plugin
export default {"container":"Notfound_container__-jr38","header":"Notfound_header__fGgq-","description":"Notfound_description__jsDbq","button":"Notfound_button__QJFmU"};